import {TrackingApi} from "./trackingApi.js";
import {Tracker} from "./tracker.js";

const trackingApi = new TrackingApi(o_global.eventQBus, o_global.debug.status().activated);
new Tracker(trackingApi);